module.exports = __webpack_public_path__ + "img/15ne.4cb64b76.svg";